import React from 'react';

export function Badge({ children, tone = 'burgundy', soft = false, iconLeft = null, style = {}, ...rest }) {
  const solid = {
    burgundy: { background: 'var(--burgundy-700)', color: '#fff' },
    navy: { background: 'var(--navy-800)', color: '#fff' },
    tan: { background: 'var(--tan-600)', color: '#fff' },
    success: { background: 'var(--success)', color: '#fff' },
    neutral: { background: 'var(--ink-600)', color: '#fff' },
  };
  const softTone = {
    burgundy: { background: 'var(--burgundy-100)', color: 'var(--burgundy-700)' },
    navy: { background: 'var(--navy-100)', color: 'var(--navy-800)' },
    tan: { background: 'var(--tan-200)', color: 'var(--tan-700)' },
    success: { background: '#e3f0e8', color: 'var(--success)' },
    neutral: { background: 'var(--cream)', color: 'var(--ink-600)' },
  };
  const palette = soft ? softTone[tone] : solid[tone];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '5px 13px',
        fontFamily: 'var(--font-ui)',
        fontSize: '12px',
        fontWeight: 600,
        letterSpacing: '0.04em',
        lineHeight: 1.4,
        borderRadius: 'var(--radius-pill)',
        ...palette,
        ...style,
      }}
      {...rest}
    >
      {iconLeft}
      {children}
    </span>
  );
}
